var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87025 6.58192C4.98874 6.451 5.15708 6.3763 5.33366 6.3763H18.667C18.8448 6.3763 19.0141 6.45201 19.1327 6.58448C19.2513 6.71694 19.3078 6.89363 19.2882 7.07032L17.9715 18.9201C17.9095 19.4808 17.6428 19.9989 17.2224 20.3753C16.8022 20.7516 16.2578 20.9597 15.6937 20.9596H8.30704C7.74288 20.9597 7.1985 20.7516 6.7782 20.3753C6.35843 19.9994 6.09185 19.4821 6.02935 18.9222L5.12834 11.2302L4.71176 7.06349C4.69419 6.88779 4.75176 6.71285 4.87025 6.58192ZM6.02428 7.6263L6.3717 11.1005L7.27155 18.7826C7.29975 19.0374 7.42098 19.273 7.61203 19.444C7.80308 19.6151 8.05051 19.7097 8.30695 19.7096H15.6937C15.9501 19.7097 16.1976 19.6151 16.3886 19.444C16.5797 19.273 16.7009 19.0374 16.7291 18.7826L17.9687 7.6263H6.02428Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9304 4.45476C14.7635 4.34898 14.5699 4.29287 14.3723 4.29297L9.62866 4.29297C9.43113 4.29297 9.23766 4.34913 9.07084 4.4549C8.90403 4.56067 8.77073 4.71168 8.68649 4.89032L7.98594 6.3763H16.015L15.315 4.89036C15.2307 4.71171 15.0973 4.5605 14.9304 4.45476ZM14.372 3.04297C14.8066 3.04281 15.2324 3.16626 15.5995 3.39891C15.9667 3.63163 16.2602 3.96401 16.4456 4.35724L17.5657 6.73495C17.6569 6.92855 17.6427 7.15536 17.5281 7.33608C17.4135 7.5168 17.2143 7.6263 17.0003 7.6263H7.00033C6.78628 7.6263 6.58713 7.51677 6.4725 7.33601C6.35788 7.15524 6.34373 6.9284 6.435 6.73479L7.55583 4.35729C7.74117 3.96423 8.03448 3.63192 8.40148 3.39922C8.76849 3.16652 9.1941 3.04297 9.62866 3.04297M9.62866 3.04297H14.372H9.62866Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04199 7.0013C3.04199 6.65612 3.32181 6.3763 3.66699 6.3763H20.3337C20.6788 6.3763 20.9587 6.65612 20.9587 7.0013C20.9587 7.34648 20.6788 7.6263 20.3337 7.6263H3.66699C3.32181 7.6263 3.04199 7.34648 3.04199 7.0013Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3337 10.543C10.6788 10.543 10.9587 10.8228 10.9587 11.168V15.3346C10.9587 15.6798 10.6788 15.9596 10.3337 15.9596C9.98848 15.9596 9.70866 15.6798 9.70866 15.3346V11.168C9.70866 10.8228 9.98848 10.543 10.3337 10.543Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.667 10.543C14.0122 10.543 14.292 10.8228 14.292 11.168V15.3346C14.292 15.6798 14.0122 15.9596 13.667 15.9596C13.3218 15.9596 13.042 15.6798 13.042 15.3346V11.168C13.042 10.8228 13.3218 10.543 13.667 10.543Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashGrey);
export default __webpack_public_path__ + "static/media/TrashGrey.945880c50c351774afb7abf1cae69f9c.svg";
export { ForwardRef as ReactComponent };